// NOTE: While we use the term digests internally everything external should
// stick to the new "Subscription"/"subscribe" terminology.
// https://mixpanel.slack.com/archives/C06AE1PB2JF/p1708532996312809?thread_ts=1708531523.786939&cid=C06AE1PB2JF
export const DIGEST_COPY = {
  createDigestSuccess: `Subscription created`,
  createDigestError: `There was an error creating the subscription.`,
  deleteDigestError: `There was an error deleting the subscription.`,
  deleteDigestSuccess: `Subscription deleted`,
  deleteDigestTitle: `Delete Subscription`,
  emailNoResults: `No existing users found. You can enter an email address to add an external subscriber.`,
  missingPermissions: `You don't have the proper permissions to create or manage subscriptions.`,
  sendTestDigestEmailSuccess: `Your test email will be sent shortly.`,
  sendTestDigestSlackSuccess: `Your test Slack message will be sent shortly.`,
  sendTestDigestEmailConfirmation: `This will send an email to the recipients you have selected. The content of this email may contain sensitive data.`,
  sendTestDigestSlackConfirmation: `This will send a message to the Slack channels you have selected. You may not have permissions in Slack to delete the message afterward.`,
  removingFinalSubscriberWillDeleteDigestPrompt: `Removing the last subscriber will delete the subscription. Are you sure you want to delete it?`,
  updateDigestError: `There was an error updating the subscription.`,
  updateDigestSuccess: `Subscription updated`,
};
